import type { CheckoutStep, CheckoutStepStatus } from '@t/checkout.types';
// Deep import of the data-only module keeps the store's import graph free of
// step component trees, even if stepContent is ever re-exported from the barrel.
import { STEP_DESCRIPTORS } from '@components/Checkout/utils/stepDescriptors/stepDescriptors';
import type { CheckoutFormField, SkipContext } from '@components/Checkout/utils/stepDescriptors/stepDescriptors.types';

export const STEP_ORDER: readonly CheckoutStep[] = STEP_DESCRIPTORS.map((d) => d.key);

export const STEP_LABELS: Record<CheckoutStep, string> = Object.fromEntries(
  STEP_DESCRIPTORS.map((d) => [d.key, d.label])
) as Record<CheckoutStep, string>;

export const STEP_FORM_FIELD: Record<CheckoutStep, CheckoutFormField | null> = Object.fromEntries(
  STEP_DESCRIPTORS.map((d) => [d.key, d.formField])
) as Record<CheckoutStep, CheckoutFormField | null>;

export const activeSteps = (ctx: SkipContext): CheckoutStep[] =>
  STEP_DESCRIPTORS.filter((d) => !d.skipWhen?.(ctx)).map((d) => d.key);

export const buildDefaultStepStatuses = (): Record<CheckoutStep, CheckoutStepStatus> =>
  STEP_ORDER.reduce(
    (acc, step, i) => {
      acc[step] = i === 0 ? 'active' : 'pending';
      return acc;
    },
    {} as Record<CheckoutStep, CheckoutStepStatus>
  );
